import axios from 'axios'

const sendTgMessage = ({ telegramChatId, threadId, msg }) => {
  const token = '8013194585:AAGF-7VzYhYbOQvupJ9ln8UV2BwxRyMwL78'
  const message = msg.replace(/([-_~>#+=|\(\){}.!])/g, '\\$1')
  return axios.post(
    `https://api.telegram.org/bot${token}/sendMessage?chat_id=${telegramChatId}&reply_to_message_id=${threadId}&parse_mode=MarkdownV2`,
    {
      text: message,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

export default sendTgMessage
